export var config = {
    onUnhandledError: null,
    onStoppedNotification: null,
};
//# sourceMappingURL=config.js.map